import {
  PLAY_BADGE_SIZE_PX,
  PROGRESS_BAR_HEIGHT_PX,
  SPINNER_DIAMETER_PX,
  THUMBNAIL_HEIGHT_PX,
  THUMBNAIL_WIDTH_PX,
  UPLOADED_VIDEO_LOADING_HEIGHT_PX,
} from './sharedConstants';

export {
  LOADING_TEST_ID,
  UPLOAD_PROGRESS_TEST_ID,
  UPLOADED_VIDEO_ASPECT_RATIO,
  UPLOADED_VIDEO_TEST_ID,
} from './sharedConstants';

export type ExampleIntroVideo = {
  /** Stable identifier used as the React key and passed back on press */
  id: string;
  /** Thumbnail shown in the examples row */
  thumbnailSrc: string;
  /** CDN-hosted MP4 the example plays from */
  videoUrl: string;
};

export const MAX_VIDEO_DURATION_SECONDS = 60;
export const MAX_FILE_SIZE_MB = 500;
export const MAX_FILE_SIZE_BYTES = MAX_FILE_SIZE_MB * 1024 * 1024;
export const ACCEPTED_VIDEO_MIME_TYPES = 'video/mp4,video/quicktime';
export const FILE_INPUT_TEST_ID = 'intro-video-file-input';
export const UPLOAD_CARD_TEST_ID = 'intro-video-upload-card';
export const UPLOAD_PROGRESS_BAR_HEIGHT = `${PROGRESS_BAR_HEIGHT_PX}px`;
export const UPLOAD_PROGRESS_BAR_MAX_WIDTH = '320px';
export const UPLOAD_PROGRESS_SPINNER_DIAMETER = SPINNER_DIAMETER_PX;

export const CONTENT_MAX_WIDTH = '640px';
export const UPLOAD_ICON_SIZE = '48px';
export const SAFETY_REVIEW_ICON_SIZE = '56px';
export const SAFETY_REVIEW_MAX_WIDTH = '480px';
export const SAFETY_REVIEW_ICON_TEST_ID = 'intro-video-safety-review-icon';
export const UPLOAD_DESCRIPTION_MAX_WIDTH = '320px';
export const THUMBNAIL_WIDTH = `${THUMBNAIL_WIDTH_PX}px`;
export const THUMBNAIL_HEIGHT = `${THUMBNAIL_HEIGHT_PX}px`;
export const PLAY_BADGE_SIZE = `${PLAY_BADGE_SIZE_PX}px`;

export const REPLACE_FILE_INPUT_TEST_ID = 'intro-video-replace-file-input';
export const UPLOADED_VIDEO_BACKDROP_BLUR = '24px';
export const PLAY_BUTTON_SIZE = '72px';
export const UPLOADED_VIDEO_LOADING_HEIGHT = `${UPLOADED_VIDEO_LOADING_HEIGHT_PX}px`;

/**
 * The marketing instapage the recording-tips link opens.
 *
 * Placeholder: the real page is a launch-blocking marketing deliverable, so this
 * slug still needs confirming before the gate opens.
 */
export const RECORDING_TIPS_URL = 'https://get.rover.com/intro-video-tips';

/** How wide the example player gets on a desktop viewport */
export const EXAMPLE_VIDEO_MAX_WIDTH = '760px';

export const EXAMPLE_VIDEO_MAX_HEIGHT = 'calc(100dvh - 160px)';

/**
 * The three marketing examples the guidelines panel shows by default.
 */
const EXAMPLE_VIDEO_BASE_URL =
  'https://drykxb4jlqvve.cloudfront.net/encoded/BQkG4e1Q/person/BQkG4e1Q/2026-09-01';

const exampleVideo = (id: string, jobPrefix: string): ExampleIntroVideo => ({
  id,
  videoUrl: `${EXAMPLE_VIDEO_BASE_URL}/${jobPrefix}/h264-high.mp4`,
  thumbnailSrc: `${EXAMPLE_VIDEO_BASE_URL}/${jobPrefix}/thumbnail.png`,
});

export const DEFAULT_EXAMPLE_VIDEOS: ExampleIntroVideo[] = [
  exampleVideo('example-1', '8gRY82N7'),
  exampleVideo('example-2', 'EjgXVjAR'),
  exampleVideo('example-3', '0Q1DbygX'),
];
